import {
	useHyperFills,
	useHyperFundingHistory,
	useHyperOrderHistory,
	useHyperTwapHistory,
	useHyperTwapSliceFills,
} from "#/hooks/use-hyperliquid-account";

export function useTradeFills(enabled = true) {
	const { fills, fetchNextPage, hasNextPage, isFetchingNextPage, ...query } =
		useHyperFills(enabled);

	return {
		...query,
		fills,
		fetchNextPage,
		hasNextPage,
		isFetchingNextPage,
	};
}

export function useTradeFundingHistory(enabled = true) {
	const {
		fundingHistory,
		fetchNextPage,
		hasNextPage,
		isFetchingNextPage,
		...query
	} = useHyperFundingHistory(enabled);
	return {
		...query,
		fundingHistory,
		fetchNextPage,
		hasNextPage,
		isFetchingNextPage,
	};
}

export function useTradeOrderHistory(enabled = true) {
	const { orderHistory, ...query } = useHyperOrderHistory(enabled);
	return { ...query, orderHistory };
}

export function useTradeTwapHistory(enabled = true) {
	const { twapHistory, ...query } = useHyperTwapHistory(enabled);
	return { ...query, twapHistory };
}

export function useTradeTwapSliceFills(enabled = true) {
	const { twapSliceFills, ...query } = useHyperTwapSliceFills(enabled);
	return { ...query, twapSliceFills };
}
